export * from './mensaje-detail/mensaje-detail.component';
export * from './mensaje-table/mensaje-table.component';
